<template>
  <footer class="bg-neutral text-neutral-content">
    <div class="footer max-w-7xl mx-auto p-10">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Brand section -->
        <div class="col-span-1 md:col-span-2">
          <div class="flex items-center space-x-3 mb-4">
            <BostelloLogo size="sm" class-name="h-8 w-auto" />
            <span class="text-xl font-bold">Admin Panel</span>
          </div>
          <p class="text-neutral-content/70 text-sm mb-4">
            Professional user management and role-based access control for the Bostello platform.
          </p>
          <div class="flex space-x-4">
            <a
              href="https://bostello.com"
              target="_blank"
              rel="noopener noreferrer"
              class="text-neutral-content/70 hover:text-neutral-content transition-colors"
            >
              <span class="sr-only">Bostello</span>
              <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                />
              </svg>
            </a>
          </div>
        </div>

        <!-- Quick links -->
        <div>
          <h3 class="text-sm font-semibold text-neutral-content/90 tracking-wider uppercase mb-4">
            Quick Links
          </h3>
          <ul class="space-y-2">
            <li>
              <router-link
                to="/"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Dashboard
              </router-link>
            </li>
            <li>
              <router-link
                to="/users"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Users
              </router-link>
            </li>
            <li>
              <router-link
                to="/roles"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Roles
              </router-link>
            </li>
            <li>
              <router-link
                to="/permissions"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Permissions
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Support -->
        <div>
          <h3 class="text-sm font-semibold text-neutral-content/80 tracking-wider uppercase mb-4">
            Support
          </h3>
          <ul class="space-y-2">
            <li>
              <a
                href="https://bostello.com"
                target="_blank"
                rel="noopener noreferrer"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Bostello Platform
              </a>
            </li>
            <li>
              <a
                href="mailto:support@bostello.com"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Contact Support
              </a>
            </li>
            <li>
              <a
                href="https://docs.bostello.com"
                target="_blank"
                rel="noopener noreferrer"
                class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
              >
                Documentation
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom section -->
      <div class="mt-8 pt-8 border-t border-neutral/50">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-neutral-content/70 text-sm">
            © {{ new Date().getFullYear() }} Bostello. All rights reserved.
          </p>
          <div class="flex space-x-6 mt-4 md:mt-0">
            <a
              href="#"
              class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              class="text-neutral-content/70 hover:text-neutral-content transition-colors text-sm"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import BostelloLogo from '@/components/BostelloLogo.vue'
</script>
